import React, {useState, useEffect,useContext} from "react";
import { Box, Button, Menu, MenuItem } from "@mui/material";
import ProfileImage from "assets/img/profile-pic.png";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ProfileDropdownStyles from "./ProfileDropdown.module.css";
import CompanyModal from "components/Content/Modal/CompanyModal";
import {useStoreState, useStoreActions} from 'easy-peasy';
import { PrivateRoutesContext } from "app/PrivateRoutesContext";
import { PortalNames } from "common/Portals";

function Dropdown(props) {
  const { modalIsOpen, currentPortal, setCurrentPortal, portals } = useContext(PrivateRoutesContext);
  const {testState, secondState} = useStoreState(state => state.companyListing);
  const {updateThisState} = useStoreActions(action => action.companyListing);

  const [anchorEl, setAnchorEl] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [arrowRotate, setArrowRotate] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setArrowRotate(!arrowRotate);
  };

  useEffect(() => {
    if(modalIsOpen){
      openCompanyDropdown()
    }
  }, [modalIsOpen]);

  const handleLogout = () => {
    window.location.href=`/logout`;
  }
  const handleClose = () => {
    setAnchorEl(null);
    setArrowRotate(!arrowRotate);
  };
  const handleSettings = () => {
    window.location.href=`/${PortalNames.Employer.Path}/settings`;
  }

  const openCompanyDropdown = () => {
    handleClose();
    setOpenModal(true);
    // console.log(testState,"testState");
    updateThisState("This is updated");
    // console.log(testState, "updateThisState");
  }

  const doDisplayPortalLink = (name) => {
    return portals && portals.filter(p => p.Portal === name).length > 0 && currentPortal !== name;
  }

  return (
      <div>
        <Button
          aria-controls="profile-menu"
          aria-haspopup="true"
          onClick={handleClick}
          className={
            arrowRotate === true ? ProfileDropdownStyles.profileDropdown : null
          }
        >
          {/* <img src={ProfileImage} alt="profile" /> */}
          <Box component="span" sx={{color:"secondary.main"}}>{props.name}</Box>{" "}
          <ExpandMoreIcon />
        </Button>
        <Menu
          id="profile-menu"
          anchorEl={anchorEl}
          // keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          style={{color: "#000da1"}}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          {(currentPortal !== PortalNames.Employee.Name && currentPortal !== PortalNames.Contractor.Name) ? <MenuItem onClick={() => openCompanyDropdown()}>Change Company</MenuItem> : null}
          {doDisplayPortalLink(PortalNames.Partner.Name) ? <MenuItem onClick={() => setCurrentPortal(PortalNames.Partner.Name)}>AP3 Dashboard</MenuItem> : null}
          {doDisplayPortalLink(PortalNames.Broker.Name) ? <MenuItem onClick={() => setCurrentPortal(PortalNames.Broker.Name)}>Broker Dashboard</MenuItem> : null}
          {doDisplayPortalLink(PortalNames.Employer.Name) ? <MenuItem onClick={() => setCurrentPortal(PortalNames.Employer.Name)}>Employer Portal</MenuItem> : null}
          {doDisplayPortalLink(PortalNames.Employee.Name) ? <MenuItem onClick={handleLogout}>Employee Portal</MenuItem> : null}
          {doDisplayPortalLink(PortalNames.Contractor.Name) ? <MenuItem onClick={() => setCurrentPortal(PortalNames.Contractor.Name)}>Contractor Portal</MenuItem> : null}
          {doDisplayPortalLink(PortalNames.CollectionPartner.Name) ? <MenuItem onClick={() => setCurrentPortal(PortalNames.CollectionPartner.Name)}>Collection Partner Portal</MenuItem> : null}
          {doDisplayPortalLink(PortalNames.CollectionCompany.Name) ? <MenuItem onClick={() => setCurrentPortal(PortalNames.CollectionCompany.Name)}>Collection Company Portal</MenuItem> : null}
          {doDisplayPortalLink(PortalNames.CollectionVendor.Name) ? <MenuItem onClick={() => setCurrentPortal(PortalNames.CollectionVendor.Name)}>Collection Vendor Portal</MenuItem> : null}
          {/* <MenuItem onClick={handleClose}>Profile</MenuItem>
          <MenuItem onClick={handleSettings}>Settings</MenuItem> */}
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </Menu>
        {openModal ? 
          <CompanyModal open={true} 
                        closeModal={openModal => setOpenModal(openModal) }  /> :
          <></>}
      </div>
  );
}

export default Dropdown;
